import React from 'react'
import FormTranslationComponent from './FormTranslationComponent'

const FormEditTranslation = () => {
  return <FormTranslationComponent isNew={false} />
}

export default FormEditTranslation
